<script lang="ts">
  import * as Sidebar from "$lib/components/ui/sidebar/index.js";
  import SidebarFooter from "../components/sidebar/sidebar-footer.svelte";
  import SidebarMenu from "../components/sidebar/sidebar-menu.svelte";
  import { activePageDef } from "../stores/selected-sidemenu-store";
</script>

<Sidebar.Provider>
  <Sidebar.Root collapsible="icon">
    <Sidebar.Header class="border-b border-sidebar-border px-2">
      <Sidebar.Menu>
        <Sidebar.MenuItem>
          <p class="mt-2 mb-2 ml-2">Attityde Tools</p>
        </Sidebar.MenuItem>
      </Sidebar.Menu>
    </Sidebar.Header>

    <SidebarMenu />
    <SidebarFooter />
  </Sidebar.Root>

  <svelte:component this={$activePageDef.component} />
</Sidebar.Provider>



